import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2dcd75f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "swipe_div" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_swipe, {
      autoplay: $setup.show_time,
      "lazy-render": ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.url_list, (item, index) => {
          return (_openBlock(), _createBlock(_component_van_swipe_item, {
            onClick: ($event: any) => ($setup.itme_click_fn(item)),
            class: "swipe_item",
            key: 'banner_' + index
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _ctx.webpFilters(item.image)
              }, null, 8, _hoisted_2)
            ]),
            _: 2
          }, 1032, ["onClick"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["autoplay"])
  ]))
}